







































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';

@Component
export default class SiteReportsOverview extends Mixins(OverviewMixin) {
  public dialogRec = {};
  public dialogExportOverview = false;
  public tableCfg = FieldDefs;

  get enableExportOverview() {
    return (this.dialogRec as any).sitereportlayout_id;
  }

  public async exportOverview() {
    const data = {
      // sitereport_ids: this.getSelectedIds(),
      filter: this.getFilterValues(),
      sort: this.getSortString(),
      sitereportlayout_id: (this.dialogRec as any).sitereportlayout_id
    };
    const ref = this.$refs.overview as any;
    this.api.downloadAction(this.$store, '/sitereports/export_overview/', data);
  }

  public markInvoicedState(state) {
    const overview = this.$refs.overview as any;
    const datatable = overview ? overview.$refs.datatable : null;
    const ids = Object.keys(datatable.selection);
    if (ids.length > 0) {
      this.api.postAction(this.$store, '/sitereports/set_invoiced_state/', {
        ids,
        state
      });
      datatable.selection = {};
      overview.tableUpdateData();
    }
  }
}
